module.exports = __webpack_public_path__ + "img/avatar-jay.ae8d2449.png";